import { getToken } from "../Cookies/cookies";
import React from 'react';
import {  Route,Navigate,useNavigate,useLocation, } from 'react-router-dom';

// export const PrivateRoute = ({ component: Component, ...rest }) => {
//     let accessToken = getToken(true);
    
//         return (
            
//             <Route {...rest} render={props => (
//                 accessToken
//                     ? <Component {...props} />
//                     : window.location.href = "https://uat-login.tradebulls.in"
//             )} />
            
//         )

    
// }

export const ProtectedRoute = ({ children }) => {
    let accessToken = getToken(true);
    const location = useLocation();
    console.log("token", accessToken)
    if (!accessToken) {
      return <Navigate to="/Login" replace state={{ from: location }} />;
    }
  
    return children;
  };